import { z } from 'zod';

// ============================================================================
// Admin OpenCage - Stats
// ============================================================================

export const AdminOpenCageProviderStatsSchema = z.object({
  coords: z.number(),
  opencage: z.number(),
});

export const AdminOpenCageCoverageSchema = z.object({
  boundsPct: z.number(),
  radiusPct: z.number(),
});

export const AdminOpenCageTotalsSchema = z.object({
  total: z.number(),
  withBounds: z.number(),
  withRadius: z.number(),
  provider: AdminOpenCageProviderStatsSchema,
  recentUsed24h: z.number(),
  coverage: AdminOpenCageCoverageSchema,
});

export const AdminOpenCageRateLimitSchema = z.object({
  limit: z.number(),
  remaining: z.number(),
  resetAt: z.date().nullable(),
  lastRequestAt: z.date().nullable(),
  last429At: z.date().nullable(),
  consecutive429s: z.number(),
});

export const AdminOpenCageStatsResponseSchema = z.object({
  totals: AdminOpenCageTotalsSchema,
  rateLimit: AdminOpenCageRateLimitSchema.nullable(),
});

export type AdminOpenCageProviderStats = z.infer<typeof AdminOpenCageProviderStatsSchema>;
export type AdminOpenCageCoverage = z.infer<typeof AdminOpenCageCoverageSchema>;
export type AdminOpenCageTotals = z.infer<typeof AdminOpenCageTotalsSchema>;
export type AdminOpenCageRateLimit = z.infer<typeof AdminOpenCageRateLimitSchema>;
export type AdminOpenCageStatsResponse = z.infer<typeof AdminOpenCageStatsResponseSchema>;

// ============================================================================
// Admin OpenCage - Time series
// ============================================================================

export const AdminOpenCageSeriesQuerySchema = z.object({
  days: z.number().min(1).max(90).optional(),
});

export const AdminOpenCageSeriesPointSchema = z.object({
  day: z.string(),
  created: z.number(),
  used: z.number(),
});

export const AdminOpenCageSeriesResponseSchema = z.object({
  days: z.number(),
  series: z.array(AdminOpenCageSeriesPointSchema),
});

export type AdminOpenCageSeriesQuery = z.infer<typeof AdminOpenCageSeriesQuerySchema>;
export type AdminOpenCageSeriesPoint = z.infer<typeof AdminOpenCageSeriesPointSchema>;
export type AdminOpenCageSeriesResponse = z.infer<typeof AdminOpenCageSeriesResponseSchema>;

// ============================================================================
// Admin OpenCage - Requeue
// ============================================================================

export const AdminOpenCageRequeueBodySchema = z.object({
  limit: z.number().min(10).max(1000).optional(),
});

export const AdminOpenCageRequeueResponseSchema = z.object({
  enqueued: z.number(),
  suppressed: z.number().optional(),
});

export type AdminOpenCageRequeueBody = z.infer<typeof AdminOpenCageRequeueBodySchema>;
export type AdminOpenCageRequeueResponse = z.infer<typeof AdminOpenCageRequeueResponseSchema>;
